export const SMALL = "230px";
export const BIG = "460px";
export const EXPANDED_WIDTH_RATIO = 0.75;
export const EXPANDED_WIDTH_VAR = "--chat-expanded-message-width";
export const CHAT_CARD_WIDTH_VAR = "--chat-card-max-width";
export const EXPANDED = `var(${EXPANDED_WIDTH_VAR}, ${BIG})`;
